import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { Company } from './company.interface';

export const COPMANY_INCLUDES = [
   'jobFunctions',
   'companyGroup',
   'departments',
   'workstations',
   'shifts',
   'contacts',
   'jointCommittees',
   'invoiceGroups',
   'invoiceGroups.city',
   'costCenters',
   'easypayContractGroups',
   'fulltimes',
   'city',
   'city.country',
   'workCycles',
   'city',
   'sectorType',
];

export class CompanyService {
   async getCompanies(query?: LocationQuery) {
      return await http.get<PaginatedResponse<Company>>('/companies', { params: { ...query } }).then((response) => response.data);
   }

   async getCompany(companyId: number, query?: LocationQuery) {
      return await http.get<Company>(`/companies/${companyId}`, { params: { ...query } }).then((response) => response.data);
   }

   async getCompanyByName(query: LocationQuery) {
      return await http.get(`/companies?search=${query.search}`).then((response) => response.data);
   }

   async postCompany(body: any) {
      return await http.post<Company>('/companies', body, { params: { append: 'scopes' } }).then((response) => response.data);
   }

   async putCompany(companyId: number, company: Company) {
      return await http
         .put<Company>(`/companies/${companyId}`, company, {
            params: { append: 'scopes' },
         })
         .then((response) => response.data);
   }

   async patchCompany(companyId: number, body: any) {
      return await http
         .patch(`/companies/${companyId}`, body, {
            params: { embeds: COPMANY_INCLUDES.join(), append: 'scopes' },
         })
         .then((response) => response.data);
   }

   async deleteCompany(companyId: number) {
      return await http.delete(`/companies/${companyId}`).then((response) => response.data);
   }
}
